module.exports = __webpack_public_path__ + "static/media/pic3_trial.afc7ac43.png";